@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.container {
    max-width: 100%;
    width: 100%;
    background: var(--white);
    border-radius: 20px;
    float: right;
    margin-top: 10px;
    border: 1px solid #cccccc;
    box-shadow: 0 4px 8px rgb(0 0 0 / 10%);
    overflow: hidden;
}
.mobilecontainer {
    border-bottom: 1px solid var(--gray-07);
    padding-top: 16px;
    background: var(--white);
    @include breakpoints.desktop {
        display: none;
      }
    .noBackground {
        background: none;
    }
}
.moveTop {
    top: 5%;
}

.headerSection {
    height: auto;
    padding: 10px 14px 8px;
    border-radius: 20px 20px 0px 0px;
}

.heading {
    float: none;
    width: 100%;
    padding: 0;
    font-style: normal;
    color: var(--blue-01);
    font-family: typography.$font-mont;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 1.92px;
    text-transform: uppercase;
    @include breakpoints.desktop {
        font-family: typography.$font-serif;
        font-size: 24px;
        letter-spacing: 0px;
    }
    @include breakpoints.desktop-large {
        font-size: 24px; 
        color: var(--blue-01);
        text-transform: none;
        font-family: "Instrument Serif";
        font-weight: 400;
        letter-spacing: 0px;
    }
}

.loading {
    @include breakpoints.desktop {
        width: 80%;
    }
}

.action {
    color: var(--blue-01);
    float:right;
    width:20%;
    padding: 1px 10px 0px 0px;
    text-align: right;
    text-decoration: underline;
}

.contentSection {
    background-color: var(--white);
    padding: 0 0 15px;
    @include breakpoints.desktop {
        display: block;
        overflow: hidden;
        padding: 0 0 15px;
        border-radius: 0px 0px 20px 20px;
    }
}

.contentLeft {
    float:left;
    width: 55%;
    padding-left: 10px;
    padding-top: 10px;
}

.contentRight {
    float:right;
    width:45%;
    text-align: right;
    padding-right: 10px;
    padding-top: 10px;
}

.contentLeftNoAvail {
    align-items: center;
    padding: 16px 10px;
    text-align: center;
    @include breakpoints.desktop {
        float:left;
        width: 20%;
        display: flex;        
    }
}

.contentRightNoAvail {
    color: var(--black);
    padding: 0px 10px;
    width:100%;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.02em;
    text-align: center;
    @include breakpoints.desktop {
        float:right;
        width: 80%;        
        color: rgba(35, 31, 32, 0.75);
        padding: 10px;        
    }
    span {
        text-decoration: underline;
        color: var(--blue-01);
        cursor: pointer;
    }
}

.footerPhoneLink {
    white-space: nowrap;
}

.officeName {
    font-size: 16px;
    color: black;
    font-weight: 600;
    text-decoration-line: underline;
}

.officeAddress {
    color: rgba(0, 0, 0, 0.7);
    font-size: 13px;
    font-weight: 400;
    @include breakpoints.desktop {
        font-size: 14px;
    }
}

.officePhone {
    color: var(--blue-01);
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.02em;
}

.icon {
    margin-right: 5px;
    width: 16px;
    @include breakpoints.desktop {
        width: auto;
    }
}

.medicaid {
    color: var(--blue-01);
    font-size: 10px;
    font-weight: 400;
}

.timings {
    color: var(--blue-01);    
    font-size: 14px;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.02em;
    @include breakpoints.desktop {
        font-size: 12px;
        font-weight: 400;
    }
}

.nearbyContent {
    cursor: pointer;
    display: block;
    overflow: auto;
    box-shadow: 0px 2px 6px var(--gray-03);
    margin: 7px 13px;
    padding-bottom: 7px;
    @include breakpoints.desktop {
        padding-bottom: 0px;
        margin: 0px;
        box-shadow: none;
    }
}

.closedContent {
    padding-bottom: 0px;
    margin: 0px;
    box-shadow: none;
}

.noAvailSpan {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--blue-01);
    @include breakpoints.desktop {
        margin-left: 10px;
    }
}

.contentHeader {
    background: var(--highlight-blue-03);
    border-radius: 4px 4px 0px 0px;
    height: 34px;
    align-items: center;
    display: flex;
    text-align: center;
    img {
        right: 6%;
        padding: 8px;
        @include breakpoints.desktop {
            padding: 8px;
        }
    }
    .miles {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 140%;
        align-items: center;
        letter-spacing: 0.02em;
        text-transform: lowercase;
        color: var(--blue-01);
        width: 30%;
        float: left;
        text-align: left;
    }
    .examDetails {
        font-weight: 700;
        font-size: 13px;
        line-height: 15px;
        display: block;
        align-items: center;
        text-align: right;
        color: var(--blue-01);
        width: 70%;
        letter-spacing: -0.02em;
        margin-right: 10px;
        @include breakpoints.desktop {
            font-weight: 500;
        }
    }
}
.spinner {
    margin: 0 10px 4px 0;
}

.centeredDivider {
    position: relative;

    > div {
        width: 100%;
        text-align: center;
    }

    > img {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
    }
}
